export const overviewCompaniesColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'organizationId',
    label: 'Name',
  },
  {
    name: 'position',
    label: 'Position',
  },
  {
    name: 'companyOfficialType',
    label: 'Type',
  },
  {
    name: 'signatureType',
    label: 'Signature Type',
  },
  {
    name: 'accessRight',
    label: 'Acess Right',
  },
];

export const overviewCompaniesSchema = {};
